import styles from './post-payment.module.less';

const GiveContentWrapper = ({ children, isOnShareStep }) => {
    return (
        <div className={[styles.giverInfoContainer, isOnShareStep ? styles.noTopMargin : ''].join(' ')}>
            <div className={[styles.giverInfoWrapper, isOnShareStep ? styles.previewPostShareContainer : ''].join(' ')}>
                {children}
            </div>
        </div>
    );
};

export default GiveContentWrapper;
